import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, setBlockTracking as _setBlockTracking, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = { class: "hidden-scrollbar overflow-x-scroll" };
const _hoisted_3 = { class: "table w-full divide-y divide-(--default-border-color) not-print:min-w-5xl" };
const _hoisted_4 = { class: "divide-y divide-(--default-border-color)" };
const _hoisted_5 = {
    scope: "col",
    class: "pt-3 pb-2"
};
const _hoisted_6 = {
    scope: "colgroup",
    class: "pt-3 pb-2",
    colspan: "3"
};
const _hoisted_7 = {
    key: 0,
    scope: "col",
    class: "pt-3 pb-2"
};
const _hoisted_8 = {
    scope: "col",
    class: "pt-3 pb-2"
};
const _hoisted_9 = { class: "flex justify-between items-center" };
const _hoisted_10 = ["aria-label", "title"];
const _hoisted_11 = ["colspan"];
const _hoisted_12 = { class: "text-muted collapsible-content" };
const _hoisted_13 = { class: "" };
const _hoisted_14 = {
    key: 0,
    scope: "col",
    class: "font-normal w-17/100"
};
const _hoisted_15 = { class: "divide-y divide-(--default-border-color)" };
const _hoisted_16 = { class: "whitespace-nowrap" };
const _hoisted_17 = ["textContent"];
const _hoisted_18 = ["textContent"];
const _hoisted_19 = { key: 0 };
const _hoisted_20 = ["textContent"];
const _hoisted_21 = {
    key: 0,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_22 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = { key: 0 };
const _hoisted_26 = {
    key: 1,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_27 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = ["innerHTML"];
const _hoisted_30 = { key: 0 };
const _hoisted_31 = {
    key: 2,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_32 = ["colspan"];
const _hoisted_33 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_34 = { class: "whitespace-nowrap" };
const _hoisted_35 = ["textContent"];
const _hoisted_36 = ["textContent"];
const _hoisted_37 = ["textContent"];
const _hoisted_38 = { key: 0 };
const _hoisted_39 = ["textContent"];
const _hoisted_40 = {
    key: 3,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_41 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_42 = ["innerHTML"];
const _hoisted_43 = ["innerHTML"];
const _hoisted_44 = ["innerHTML"];
const _hoisted_45 = { key: 0 };
const _hoisted_46 = {
    key: 4,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_47 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_48 = ["innerHTML"];
const _hoisted_49 = ["innerHTML"];
const _hoisted_50 = ["innerHTML"];
const _hoisted_51 = { key: 0 };
const _hoisted_52 = {
    key: 5,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_53 = ["colspan"];
const _hoisted_54 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_55 = { class: "whitespace-nowrap" };
const _hoisted_56 = ["textContent"];
const _hoisted_57 = ["textContent"];
const _hoisted_58 = ["textContent"];
const _hoisted_59 = { key: 0 };
const _hoisted_60 = ["textContent"];
const _hoisted_61 = {
    key: 6,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_62 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_63 = ["innerHTML"];
const _hoisted_64 = ["innerHTML"];
const _hoisted_65 = ["innerHTML"];
const _hoisted_66 = { key: 0 };
const _hoisted_67 = {
    key: 7,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_68 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_69 = ["innerHTML"];
const _hoisted_70 = ["innerHTML"];
const _hoisted_71 = ["innerHTML"];
const _hoisted_72 = { key: 0 };
const _hoisted_73 = {
    key: 8,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_74 = ["colspan"];
const _hoisted_75 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_76 = { class: "whitespace-nowrap" };
const _hoisted_77 = ["textContent"];
const _hoisted_78 = ["textContent"];
const _hoisted_79 = ["textContent"];
const _hoisted_80 = { key: 0 };
const _hoisted_81 = ["textContent"];
const _hoisted_82 = {
    key: 9,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_83 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_84 = ["innerHTML"];
const _hoisted_85 = ["innerHTML"];
const _hoisted_86 = ["innerHTML"];
const _hoisted_87 = { key: 0 };
const _hoisted_88 = {
    key: 10,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_89 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_90 = ["innerHTML"];
const _hoisted_91 = ["innerHTML"];
const _hoisted_92 = ["innerHTML"];
const _hoisted_93 = { key: 0 };
const _hoisted_94 = {
    key: 11,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_95 = ["colspan"];
const _hoisted_96 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_97 = { class: "whitespace-nowrap" };
const _hoisted_98 = ["textContent"];
const _hoisted_99 = ["textContent"];
const _hoisted_100 = ["textContent"];
const _hoisted_101 = { key: 0 };
const _hoisted_102 = ["textContent"];
const _hoisted_103 = {
    key: 12,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_104 = ["colspan"];
const _hoisted_105 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_106 = { class: "whitespace-nowrap" };
const _hoisted_107 = ["textContent"];
const _hoisted_108 = ["textContent"];
const _hoisted_109 = ["textContent"];
const _hoisted_110 = { key: 0 };
const _hoisted_111 = ["textContent"];
const _hoisted_112 = {
    key: 13,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_113 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_114 = ["innerHTML"];
const _hoisted_115 = ["innerHTML"];
const _hoisted_116 = ["innerHTML"];
const _hoisted_117 = { key: 0 };
const _hoisted_118 = {
    key: 14,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_119 = { class: "whitespace-nowrap ps-8 lg:ps-9" };
const _hoisted_120 = ["innerHTML"];
const _hoisted_121 = ["innerHTML"];
const _hoisted_122 = ["innerHTML"];
const _hoisted_123 = { key: 0 };
const _hoisted_124 = {
    key: 15,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_125 = ["colspan"];
const _hoisted_126 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_127 = { class: "text-end lg:hidden print:hidden text-sm text-muted" };
const _hoisted_128 = { class: "card mt-6" };
const _hoisted_129 = { class: "hidden-scrollbar overflow-x-scroll" };
const _hoisted_130 = { class: "table w-full divide-y divide-(--default-border-color) not-print:min-w-5xl" };
const _hoisted_131 = { class: "divide-y divide-(--default-border-color)" };
const _hoisted_132 = {
    scope: "col",
    class: "pt-3 pb-2"
};
const _hoisted_133 = {
    scope: "colgroup",
    class: "pt-3 pb-2",
    colspan: "3"
};
const _hoisted_134 = {
    scope: "col",
    class: "pt-3 pb-2"
};
const _hoisted_135 = {
    scope: "col",
    class: "pt-3 pb-2"
};
const _hoisted_136 = { class: "flex justify-between items-center" };
const _hoisted_137 = ["aria-label", "title"];
const _hoisted_138 = ["colspan"];
const _hoisted_139 = { class: "text-muted collapsible-content" };
const _hoisted_140 = { class: "" };
const _hoisted_141 = {
    scope: "col",
    class: "font-normal w-13/100"
};
const _hoisted_142 = {
    scope: "col",
    class: "font-normal w-17/100"
};
const _hoisted_143 = {
    scope: "col",
    class: "font-normal w-17/100"
};
const _hoisted_144 = { class: "divide-y divide-(--default-border-color)" };
const _hoisted_145 = { class: "whitespace-nowrap" };
const _hoisted_146 = ["textContent"];
const _hoisted_147 = ["textContent"];
const _hoisted_148 = ["textContent"];
const _hoisted_149 = ["textContent"];
const _hoisted_150 = {
    key: 0,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_151 = {
    colspan: "6",
    class: "ps-8 lg:ps-9"
};
const _hoisted_152 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_153 = { class: "whitespace-nowrap" };
const _hoisted_154 = ["textContent"];
const _hoisted_155 = ["textContent"];
const _hoisted_156 = ["textContent"];
const _hoisted_157 = ["textContent"];
const _hoisted_158 = {
    key: 1,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_159 = {
    colspan: "6",
    class: "ps-8 lg:ps-9"
};
const _hoisted_160 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_161 = { class: "whitespace-nowrap" };
const _hoisted_162 = ["textContent"];
const _hoisted_163 = ["textContent"];
const _hoisted_164 = ["textContent"];
const _hoisted_165 = ["textContent"];
const _hoisted_166 = {
    key: 2,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_167 = {
    colspan: "6",
    class: "ps-8 lg:ps-9"
};
const _hoisted_168 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_169 = { class: "whitespace-nowrap" };
const _hoisted_170 = ["textContent"];
const _hoisted_171 = ["textContent"];
const _hoisted_172 = ["textContent"];
const _hoisted_173 = ["textContent"];
const _hoisted_174 = {
    key: 3,
    class: "bg-(--default-bg-color) text-gray-500 dark:text-gray-300"
};
const _hoisted_175 = {
    colspan: "6",
    class: "ps-8 lg:ps-9"
};
const _hoisted_176 = { class: "inline-flex align-top items-center h-lh me-0.5" };
const _hoisted_177 = { class: "text-end lg:hidden print:hidden text-sm text-muted" };
import { computed, onMounted, ref, watch } from 'vue';
import { ___ } from '@ts/common/language';
import { kcalToG } from '@ts/common/nutrition';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Zones',
    props: {
        data: { default: undefined },
        help: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const initialZones = {};
        for (const zone of ['zone1', 'zone2', 'zone3', 'zone4', 'zone5', 'zone6']) {
            initialZones[zone] = {};
            for (const reg of ['min', 'max', 'avg']) {
                initialZones[zone][reg] = {};
                initialZones[zone][reg].power = '-';
                initialZones[zone][reg].carbohydrates = {
                    kcal: '-',
                    g: '-',
                    combined: '-',
                };
                initialZones[zone][reg].fat = {
                    kcal: '-',
                    g: '-',
                    combined: '-',
                };
                initialZones[zone].minHeartrate = '-';
                initialZones[zone].maxHeartrate = '-';
            }
        }
        for (const zone of ['zonefatmax', 'zoneie', 'zonevo2max', 'zonelc']) {
            initialZones[zone] = {};
            for (const reg of ['min', 'max', 'avg', 'rest']) {
                initialZones[zone][reg] = {};
                initialZones[zone][reg].power = '-';
            }
        }
        const showHelp1 = ref(false);
        const showHelp2 = ref(false);
        const zones = ref(initialZones);
        onMounted(() => {
            if (props.data !== undefined)
                setZones(props.data);
        });
        watch(() => props.data, (newValue, oldValue) => {
            if (newValue !== undefined)
                setZones(newValue);
        }, { deep: true });
        const has_heart_rate_coeffs = computed(() => {
            return props.data === undefined || props.data.heartrate_c0 === null || props.data.heartrate_c1 === null ? false : true;
        });
        function heartRateAtPower(heartrate_max, heartrate_c0, heartrate_c1, power) {
            return Math.round(Math.min(heartrate_max, heartrate_c0 * power + heartrate_c1));
        }
        // Analysis model Galibier (v4.2) shows carb/fat demand as a Km-swept band. Each cell renders
        // as an HTML fragment (bound with v-html): two lines — g/h then kcal/h — each showing
        // "low – centre – high" with the limits dimmed (opacity) so the centre value stands out.
        // The per-power low/high curves are scaled to the zone's centre so the range stays
        // consistent with the centre shown. Ventoux (v3.1) (no band arrays) → just the centre per line.
        // Inline styles (not Tailwind classes) keep it purgecss-proof inside the v-html string and
        // let the dimming inherit the row's theme-aware colour (works in light + dark).
        function combinedDemand(data, powerVal, centreKcal, macro) {
            const cm = data.chart_metabolism;
            const lowArr = macro === 'carb' ? cm?.energy_carbo_per_hour_low : cm?.energy_fat_per_hour_low;
            const highArr = macro === 'carb' ? cm?.energy_carbo_per_hour_high : cm?.energy_fat_per_hour_high;
            const ctrArr = macro === 'carb' ? cm?.energy_carbo_per_hour : cm?.energy_fat_per_hour;
            let lowKcal = null;
            let highKcal = null;
            if (data.performance_computations_version === '2' &&
                Array.isArray(lowArr) && Array.isArray(highArr) && Array.isArray(ctrArr)) {
                const i = Math.round(powerVal);
                if (i >= 0 && i < ctrArr.length && ctrArr[i] > 0) {
                    lowKcal = centreKcal * (lowArr[i] / ctrArr[i]);
                    highKcal = centreKcal * (highArr[i] / ctrArr[i]);
                }
            }
            // "centre (low–high) unit" — all one colour; the parentheses delimit the range.
            const renderLine = (low, centre, high, unit) => {
                // const div = `<div class="whitespace-nowrap my-0.5" style="white-space:nowrap;line-height:1.25">`;
                const div = `<div class="whitespace-nowrap my-1">`;
                if (low === null || high === null || Math.round(low) === Math.round(high)) {
                    return `${div}${Math.round(centre)} ${unit}</div>`;
                }
                return `${div}${Math.round(low)}–${Math.round(high)}&thinsp;${unit}</div>`;
                // return `${div}[${Math.round(low)}–${Math.round(high)}] ${unit}</div>`;
                // return `${div}∈ [${Math.round(low)}–${Math.round(high)}] ${unit}</div>`;
                // return `${div}${Math.round(centre)} (${Math.round(low)}–${Math.round(high)}) ${unit}</div>`;
            };
            const centreG = kcalToG(centreKcal, macro);
            const lowG = lowKcal !== null ? kcalToG(lowKcal, macro) : null;
            const highG = highKcal !== null ? kcalToG(highKcal, macro) : null;
            return renderLine(lowG, centreG, highG, 'g/h') + renderLine(lowKcal, centreKcal, highKcal, 'kcal/h');
        }
        function setZones(data) {
            let heartrateAtThreshold = undefined;
            // if (has_heart_rate_coeffs.value) {
            if (data !== undefined && data.heartrate_c0 !== null && data.heartrate_c1 !== null && data.heartrate_max !== null) {
                heartrateAtThreshold = Math.round(Math.min(data.heartrate_max - 2.0, data.heartrate_c0 * data.threshold_abs + data.heartrate_c1));
            }
            // zones.value = {};
            for (const zone of ['zone1', 'zone2', 'zone3', 'zone4', 'zone5', 'zone6']) {
                // zones.value[zone] = {};
                for (const reg of ['min', 'max', 'avg']) {
                    zones.value[zone][reg] = {};
                    zones.value[zone][reg].power = Number(Math.round(data[zone][reg]['power']));
                    if ('carbohydrates' in data[zone][reg]) {
                        const kcalCh = Number(Math.round(data[zone][reg]['carbohydrates']));
                        const gCh = kcalToG(kcalCh, 'carb').toFixed(0);
                        const kcalChStr = kcalCh.toFixed(0);
                        zones.value[zone][reg].carbohydrates = {
                            kcal: kcalChStr,
                            g: gCh,
                            combined: combinedDemand(data, zones.value[zone][reg].power, kcalCh, 'carb'),
                        };
                    }
                    else {
                        zones.value[zone][reg].carbohydrates = {
                            kcal: '-',
                            g: '-',
                            combined: '-',
                        };
                    }
                    if ('fat' in data[zone][reg]) {
                        const kcalFat = Number(Math.round(data[zone][reg]['fat']));
                        const gFat = kcalToG(kcalFat, 'fat').toFixed(0);
                        const kcalFatStr = kcalFat.toFixed(0);
                        zones.value[zone][reg].fat = {
                            kcal: kcalFatStr,
                            g: gFat,
                            combined: combinedDemand(data, zones.value[zone][reg].power, kcalFat, 'fat'),
                        };
                    }
                    else {
                        zones.value[zone][reg].fat = {
                            kcal: '-',
                            g: '-',
                            combined: '-',
                        };
                    }
                }
                if (data !== undefined && data.heartrate_c0 !== null && data.heartrate_c1 !== null && data.heartrate_max !== null) {
                    switch (zone) {
                        case 'zone1':
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.50)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.86)
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.30)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.54)
                            zones.value[zone].minHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].min.power);
                            zones.value[zone].maxHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].max.power);
                            break;
                        case 'zone2':
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.87)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.91)
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.55) // tabelle
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.75)
                            zones.value[zone].minHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].min.power); // regresseion
                            zones.value[zone].maxHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].max.power);
                            break;
                        case 'zone3':
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.92)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.96)
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.76)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.90)
                            zones.value[zone].minHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].min.power);
                            zones.value[zone].maxHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].max.power);
                            break;
                        case 'zone4':
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.97)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*1.02)
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.91)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*1.05)
                            zones.value[zone].minHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].min.power);
                            zones.value[zone].maxHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].max.power);
                            break;
                        case 'zone5':
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*1.03)
                            // zones.value[zone].maxHeartrate = Math.round(data.heartrate_max - 1.0)
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*1.06)
                            // zones.value[zone].maxHeartrate = Math.round(data.heartrate_max - 1.0)
                            zones.value[zone].minHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].min.power);
                            zones.value[zone].maxHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].max.power);
                            break;
                        case 'zone6':
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.92)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.97)
                            // zones.value[zone].minHeartrate = Math.round(heartrateAtThreshold*0.84)
                            // zones.value[zone].maxHeartrate = Math.round(heartrateAtThreshold*0.98)
                            zones.value[zone].minHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].min.power);
                            zones.value[zone].maxHeartrate = heartRateAtPower(data.heartrate_max, data.heartrate_c0, data.heartrate_c1, zones.value[zone].max.power);
                            break;
                    }
                }
                zones.value[zone].expandEnergy = false;
                zones.value[zone].hover = false;
            }
            for (const zone of ['zonefatmax', 'zoneie', 'zonevo2max', 'zonelc']) {
                // zones.value[zone] = {};
                for (const reg of ['min', 'max', 'avg', 'rest']) {
                    // zones.value[zone][reg] = {}
                    zones.value[zone][reg].power = Number(Math.round(data[zone][reg]['power']));
                }
                zones.value[zone].expandEnergy = false;
                zones.value[zone].hover = false;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("table", _hoisted_3, [
                            _createElementVNode("thead", _hoisted_4, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(___)({ en: 'Training Zones', de: 'Trainingsbereiche' })), 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(___)({ en: 'Power', de: 'Leistung' })), 1 /* TEXT */),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_unref(___)({ en: 'Heart rate', de: 'Herzfrequenz' })), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("th", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", null, _toDisplayString(_unref(___)({ en: 'Cadence', de: 'Trittfrequenz' })), 1 /* TEXT */),
                                            (__props.help)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: _cache[1] || (_cache[1] = ($event) => (showHelp1.value = !showHelp1.value)),
                                                    type: "button",
                                                    class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500 ms-3",
                                                    "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                                                    title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                                                }, [
                                                    _cache[0] || (_setBlockTracking(-1, true),
                                                        (_cache[0] = _createVNode(SvgVue, {
                                                            class: "w-4 h-4",
                                                            icon: "lucide/circle-question-mark"
                                                        })).cacheIndex = 0,
                                                        _setBlockTracking(1),
                                                        _cache[0])
                                                ], 8 /* PROPS */, _hoisted_10))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ]),
                                (__props.help)
                                    ? (_openBlock(), _createElementBlock("tr", {
                                        key: 0,
                                        class: _normalizeClass(["transition-[border-width]", showHelp1.value ? '' : 'border-t-0 border-b-0'])
                                    }, [
                                        _createElementVNode("td", {
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5,
                                            class: _normalizeClass(["transition-[padding]", showHelp1.value ? '' : 'py-0'])
                                        }, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["collapsible", showHelp1.value ? 'expanded' : ''])
                                            }, [
                                                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(___)({
                                                    en: 'Training zones help to structure the training and to set targeted training stimuli. All training zones are individual training recommendations based on the respective metabolic profile.',
                                                    de: 'Trainingsbereiche helfen dabei, das Training strukturiert zu gestalten und gezielte Trainingsreize zu setzen. Alle Trainingsbereiche sind spezifische Trainingsempfehlungen basierend auf dem individuellen metabolischen Profil.',
                                                })), 1 /* TEXT */)
                                            ], 2 /* CLASS */)
                                        ], 10 /* CLASS, PROPS */, _hoisted_11)
                                    ], 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", _hoisted_13, [
                                    _createElementVNode("th", {
                                        scope: "col",
                                        class: _normalizeClass(["font-normal", has_heart_rate_coeffs.value ? 'w-27/100' : 'w-40/100'])
                                    }, null, 2 /* CLASS */),
                                    _createElementVNode("th", {
                                        scope: "col",
                                        class: _normalizeClass(["font-normal", has_heart_rate_coeffs.value ? 'w-13/100' : 'w-12/100'])
                                    }, "min. [W]", 2 /* CLASS */),
                                    _createElementVNode("th", {
                                        scope: "col",
                                        class: _normalizeClass(["font-normal", has_heart_rate_coeffs.value ? 'w-13/100' : 'w-12/100'])
                                    }, "max. [W]", 2 /* CLASS */),
                                    _createElementVNode("th", {
                                        scope: "col",
                                        class: _normalizeClass(["font-normal", has_heart_rate_coeffs.value ? 'w-13/100' : 'w-12/100'])
                                    }, _toDisplayString(_unref(___)({ en: 'Target value', de: 'Zielwert' })) + " [W]", 3 /* TEXT, CLASS */),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_14, _toDisplayString(_unref(___)({ en: 'Guide value', de: 'Richtwert' })) + " [bpm]", 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("th", {
                                        scope: "col",
                                        class: _normalizeClass(["font-normal", has_heart_rate_coeffs.value ? 'w-17/100' : 'w-24/100'])
                                    }, _toDisplayString(_unref(___)({ en: 'Guide value', de: 'Richtwert' })) + " [rpm]", 3 /* TEXT, CLASS */)
                                ])
                            ]),
                            _createElementVNode("tbody", _hoisted_15, [
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zone1.showEnergy, 'text-primary-500': zones.value.zone1.hover }]),
                                    onMouseover: _cache[2] || (_cache[2] = ($event) => (zones.value.zone1.hover = true)),
                                    onMouseleave: _cache[3] || (_cache[3] = ($event) => (zones.value.zone1.hover = false)),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (zones.value.zone1.showEnergy = !zones.value.zone1.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_16, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zone1.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[48] || (_cache[48] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Active Recovery (AR)', de: 'Kompensation (KB)' })), 1 /* TEXT */)
                                    ]),
                                    _cache[49] || (_cache[49] = _createElementVNode("td", null, "-", -1 /* CACHED */)),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone1.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_17)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone1.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_18)
                                    ]),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                            _createElementVNode("span", {
                                                textContent: _toDisplayString('< ' + zones.value.zone1.maxHeartrate)
                                            }, null, 8 /* PROPS */, _hoisted_20)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[50] || (_cache[50] = _createElementVNode("td", null, "80-100", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zone1.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                                        _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(___)({ en: 'Carbohydrate consumption ', de: 'Kohlenhydratverbrauch ' })), 1 /* TEXT */),
                                        _cache[51] || (_cache[51] = _createElementVNode("td", null, "-", -1 /* CACHED */)),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone1.max.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_23)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone1.avg.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_24)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_25))
                                            : _createCommentVNode("v-if", true),
                                        _cache[52] || (_cache[52] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone1.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                                        _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(___)({ en: 'Energy consumption fat', de: 'Energieverbrauch Fett' })), 1 /* TEXT */),
                                        _cache[53] || (_cache[53] = _createElementVNode("td", null, "-", -1 /* CACHED */)),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone1.max.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_28)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone1.avg.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_29)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_30))
                                            : _createCommentVNode("v-if", true),
                                        _cache[54] || (_cache[54] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone1.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                        _createElementVNode("td", {
                                            class: "ps-8 lg:ps-9",
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5
                                        }, [
                                            _createElementVNode("div", _hoisted_33, [
                                                _cache[5] || (_setBlockTracking(-1, true),
                                                    (_cache[5] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 5,
                                                    _setBlockTracking(1),
                                                    _cache[5])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Is used for active recovery. Low intensity.',
                                                de: 'Dient der aktiven Regeneration. Geringe Intensität.',
                                            })), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_32)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zone2.showEnergy, 'text-primary-500': zones.value.zone2.hover }]),
                                    onMouseover: _cache[6] || (_cache[6] = ($event) => (zones.value.zone2.hover = true)),
                                    onMouseleave: _cache[7] || (_cache[7] = ($event) => (zones.value.zone2.hover = false)),
                                    onClick: _cache[8] || (_cache[8] = ($event) => (zones.value.zone2.showEnergy = !zones.value.zone2.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_34, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zone2.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[55] || (_cache[55] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Basic Endurance 1 (E1)', de: 'Grundlagenausdauer 1 (G1)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone2.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_35)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone2.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_36)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone2.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_37)
                                    ]),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                                            _createElementVNode("span", {
                                                textContent: _toDisplayString(zones.value.zone2.minHeartrate + '-' + zones.value.zone2.maxHeartrate)
                                            }, null, 8 /* PROPS */, _hoisted_39)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[56] || (_cache[56] = _createElementVNode("td", null, "85-110", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zone2.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                        _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(___)({ en: 'Carbohydrate consumption ', de: 'Kohlenhydratverbrauch ' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone2.min.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_42)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone2.max.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_43)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone2.avg.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_44)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_45))
                                            : _createCommentVNode("v-if", true),
                                        _cache[57] || (_cache[57] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone2.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                                        _createElementVNode("td", _hoisted_47, _toDisplayString(_unref(___)({ en: 'Energy consumption fat', de: 'Energieverbrauch Fett' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone2.min.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_48)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone2.max.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_49)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone2.avg.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_50)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_51))
                                            : _createCommentVNode("v-if", true),
                                        _cache[58] || (_cache[58] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone2.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                                        _createElementVNode("td", {
                                            class: "ps-8 lg:ps-9",
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5
                                        }, [
                                            _createElementVNode("div", _hoisted_54, [
                                                _cache[9] || (_setBlockTracking(-1, true),
                                                    (_cache[9] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 9,
                                                    _setBlockTracking(1),
                                                    _cache[9])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Fundamental training to improve the aerobic performance. Moderate intensity.',
                                                de: 'Grundlagentraining zur Verbesserung der aeroben Leistungsfähigkeit. Moderate Intensität.',
                                            })), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_53)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zone3.showEnergy, 'text-primary-500': zones.value.zone3.hover }]),
                                    onMouseover: _cache[10] || (_cache[10] = ($event) => (zones.value.zone3.hover = true)),
                                    onMouseleave: _cache[11] || (_cache[11] = ($event) => (zones.value.zone3.hover = false)),
                                    onClick: _cache[12] || (_cache[12] = ($event) => (zones.value.zone3.showEnergy = !zones.value.zone3.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_55, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zone3.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[59] || (_cache[59] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Basic Endurance 2 (E2)', de: 'Grundlagenausdauer 2 (G2)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone3.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_56)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone3.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_57)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone3.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_58)
                                    ]),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_59, [
                                            _createElementVNode("span", {
                                                textContent: _toDisplayString(zones.value.zone3.minHeartrate + '-' + zones.value.zone3.maxHeartrate)
                                            }, null, 8 /* PROPS */, _hoisted_60)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[60] || (_cache[60] = _createElementVNode("td", null, "85-110", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zone3.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [
                                        _createElementVNode("td", _hoisted_62, _toDisplayString(_unref(___)({ en: 'Carbohydrate consumption ', de: 'Kohlenhydratverbrauch ' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone3.min.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_63)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone3.max.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_64)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone3.avg.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_65)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_66))
                                            : _createCommentVNode("v-if", true),
                                        _cache[61] || (_cache[61] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone3.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_67, [
                                        _createElementVNode("td", _hoisted_68, _toDisplayString(_unref(___)({ en: 'Energy consumption fat', de: 'Energieverbrauch Fett' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone3.min.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_69)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone3.max.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_70)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone3.avg.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_71)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_72))
                                            : _createCommentVNode("v-if", true),
                                        _cache[62] || (_cache[62] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone3.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_73, [
                                        _createElementVNode("td", {
                                            class: "ps-8 lg:ps-9",
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5
                                        }, [
                                            _createElementVNode("div", _hoisted_75, [
                                                _cache[13] || (_setBlockTracking(-1, true),
                                                    (_cache[13] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 13,
                                                    _setBlockTracking(1),
                                                    _cache[13])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Fundamental training to improve the aerobic performance. Medium intensity.',
                                                de: 'Grundlagentraining zur Verbesserung der aeroben Leistungsfähigkeit. Mittlere Intensität.',
                                            })), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_74)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zone4.showEnergy, 'text-primary-500': zones.value.zone4.hover }]),
                                    onMouseover: _cache[14] || (_cache[14] = ($event) => (zones.value.zone4.hover = true)),
                                    onMouseleave: _cache[15] || (_cache[15] = ($event) => (zones.value.zone4.hover = false)),
                                    onClick: _cache[16] || (_cache[16] = ($event) => (zones.value.zone4.showEnergy = !zones.value.zone4.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_76, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zone4.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[63] || (_cache[63] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Threshold (TH)', de: 'Entwicklungsbereich (EB)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone4.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_77)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone4.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_78)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone4.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_79)
                                    ]),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_80, [
                                            _createElementVNode("span", {
                                                textContent: _toDisplayString(zones.value.zone4.minHeartrate + '-' + zones.value.zone4.maxHeartrate)
                                            }, null, 8 /* PROPS */, _hoisted_81)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[64] || (_cache[64] = _createElementVNode("td", null, "85-110", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zone4.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [
                                        _createElementVNode("td", _hoisted_83, _toDisplayString(_unref(___)({ en: 'Carbohydrate consumption ', de: 'Kohlenhydratverbrauch ' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone4.min.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_84)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone4.max.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_85)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone4.avg.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_86)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_87))
                                            : _createCommentVNode("v-if", true),
                                        _cache[65] || (_cache[65] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone4.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_88, [
                                        _createElementVNode("td", _hoisted_89, _toDisplayString(_unref(___)({ en: 'Energy consumption fat', de: 'Energieverbrauch Fett' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone4.min.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_90)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone4.max.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_91)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone4.avg.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_92)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_93))
                                            : _createCommentVNode("v-if", true),
                                        _cache[66] || (_cache[66] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone4.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_94, [
                                        _createElementVNode("td", {
                                            class: "ps-8 lg:ps-9",
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5
                                        }, [
                                            _createElementVNode("div", _hoisted_96, [
                                                _cache[17] || (_setBlockTracking(-1, true),
                                                    (_cache[17] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 17,
                                                    _setBlockTracking(1),
                                                    _cache[17])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Training at the anaerobic threshold. High intensity.',
                                                de: 'Training an der anaeroben Schwelle. Hohe Intensität.',
                                            })), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_95)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zone5.showEnergy, 'text-primary-500': zones.value.zone5.hover }]),
                                    onMouseover: _cache[18] || (_cache[18] = ($event) => (zones.value.zone5.hover = true)),
                                    onMouseleave: _cache[19] || (_cache[19] = ($event) => (zones.value.zone5.hover = false)),
                                    onClick: _cache[20] || (_cache[20] = ($event) => (zones.value.zone5.showEnergy = !zones.value.zone5.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_97, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zone5.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[67] || (_cache[67] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'High Intensity (HI)', de: 'Spitzenbereich (SB)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone5.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_98)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone5.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_99)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone5.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_100)
                                    ]),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_101, [
                                            _createElementVNode("span", {
                                                textContent: _toDisplayString(zones.value.zone5.minHeartrate + '-' + zones.value.zone5.maxHeartrate)
                                            }, null, 8 /* PROPS */, _hoisted_102)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[68] || (_cache[68] = _createElementVNode("td", null, "95-120", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zone5.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_103, [
                                        _createElementVNode("td", {
                                            class: "ps-8 lg:ps-9",
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5
                                        }, [
                                            _createElementVNode("div", _hoisted_105, [
                                                _cache[21] || (_setBlockTracking(-1, true),
                                                    (_cache[21] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 21,
                                                    _setBlockTracking(1),
                                                    _cache[21])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Training of aerobic and anaerobic capacity. Very high intensity.',
                                                de: 'Training der aeroben und anaeroben Kapazität. Sehr hohe Intensität.',
                                            })), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_104)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zone6.showEnergy, 'text-primary-500': zones.value.zone6.hover }]),
                                    onMouseover: _cache[22] || (_cache[22] = ($event) => (zones.value.zone6.hover = true)),
                                    onMouseleave: _cache[23] || (_cache[23] = ($event) => (zones.value.zone6.hover = false)),
                                    onClick: _cache[24] || (_cache[24] = ($event) => (zones.value.zone6.showEnergy = !zones.value.zone6.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_106, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zone6.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[69] || (_cache[69] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Strength Endurance (SE)', de: 'Kraftausdauer (K3)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone6.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_107)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone6.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_108)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zone6.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_109)
                                    ]),
                                    (has_heart_rate_coeffs.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_110, [
                                            _createElementVNode("span", {
                                                textContent: _toDisplayString(zones.value.zone6.minHeartrate + '-' + zones.value.zone6.maxHeartrate)
                                            }, null, 8 /* PROPS */, _hoisted_111)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[70] || (_cache[70] = _createElementVNode("td", null, "40-60", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zone6.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_112, [
                                        _createElementVNode("td", _hoisted_113, _toDisplayString(_unref(___)({ en: 'Carbohydrate consumption ', de: 'Kohlenhydratverbrauch ' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone6.min.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_114)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone6.max.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_115)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone6.avg.carbohydrates.combined
                                            }, null, 8 /* PROPS */, _hoisted_116)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_117))
                                            : _createCommentVNode("v-if", true),
                                        _cache[71] || (_cache[71] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone6.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_118, [
                                        _createElementVNode("td", _hoisted_119, _toDisplayString(_unref(___)({ en: 'Energy consumption fat', de: 'Energieverbrauch Fett' })), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone6.min.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_120)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone6.max.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_121)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                innerHTML: zones.value.zone6.avg.fat.combined
                                            }, null, 8 /* PROPS */, _hoisted_122)
                                        ]),
                                        (has_heart_rate_coeffs.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_123))
                                            : _createCommentVNode("v-if", true),
                                        _cache[72] || (_cache[72] = _createElementVNode("td", null, null, -1 /* CACHED */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (zones.value.zone6.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_124, [
                                        _createElementVNode("td", {
                                            class: "ps-8 lg:ps-9",
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5
                                        }, [
                                            _createElementVNode("div", _hoisted_126, [
                                                _cache[25] || (_setBlockTracking(-1, true),
                                                    (_cache[25] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 25,
                                                    _setBlockTracking(1),
                                                    _cache[25])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Economization of energy metabolism. Medium intensity at low cadence.',
                                                de: 'Ökonomisierung des Energiestoffwechsels. Mittlere Intensität bei geringer Trittfrequenz.',
                                            })), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_125)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_127, [
                    _cache[26] || (_setBlockTracking(-1, true),
                        (_cache[26] = _createVNode(SvgVue, {
                            class: "w-3 h-3 inline-block",
                            icon: "lucide/chevron-left"
                        })).cacheIndex = 26,
                        _setBlockTracking(1),
                        _cache[26]),
                    _cache[73] || (_cache[73] = _createTextVNode("swipe me", -1 /* CACHED */)),
                    _cache[27] || (_setBlockTracking(-1, true),
                        (_cache[27] = _createVNode(SvgVue, {
                            class: "w-3 h-3 inline-block",
                            icon: "lucide/chevron-right"
                        })).cacheIndex = 27,
                        _setBlockTracking(1),
                        _cache[27])
                ]),
                _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("table", _hoisted_130, [
                            _createElementVNode("thead", _hoisted_131, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_132, _toDisplayString(_unref(___)({ en: 'Specific Training Zones', de: 'Spezifische Trainingsbereiche' })), 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_133, _toDisplayString(_unref(___)({ en: 'Power (Interval)', de: 'Leistung (Interval)' })), 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_134, _toDisplayString(_unref(___)({ en: 'Power (Rest)', de: 'Leistung (Pause)' })), 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_135, [
                                        _createElementVNode("div", _hoisted_136, [
                                            _createElementVNode("div", null, _toDisplayString(_unref(___)({ en: 'Cadence', de: 'Trittfrequenz' })), 1 /* TEXT */),
                                            (__props.help)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: _cache[29] || (_cache[29] = ($event) => (showHelp2.value = !showHelp2.value)),
                                                    type: "button",
                                                    class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500 ms-3",
                                                    "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                                                    title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                                                }, [
                                                    _cache[28] || (_setBlockTracking(-1, true),
                                                        (_cache[28] = _createVNode(SvgVue, {
                                                            class: "w-4 h-4",
                                                            icon: "lucide/circle-question-mark"
                                                        })).cacheIndex = 28,
                                                        _setBlockTracking(1),
                                                        _cache[28])
                                                ], 8 /* PROPS */, _hoisted_137))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ]),
                                (__props.help)
                                    ? (_openBlock(), _createElementBlock("tr", {
                                        key: 0,
                                        class: _normalizeClass(["transition-[border-width]", showHelp2.value ? '' : 'border-t-0 border-b-0'])
                                    }, [
                                        _createElementVNode("td", {
                                            colspan: has_heart_rate_coeffs.value ? 6 : 5,
                                            class: _normalizeClass(["transition-[padding]", showHelp2.value ? '' : 'py-0'])
                                        }, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["collapsible", showHelp2.value ? 'expanded' : ''])
                                            }, [
                                                _createElementVNode("div", _hoisted_139, _toDisplayString(_unref(___)({
                                                    en: 'The training methods describe zones for specific training stimuli and are based on the individual metabolic profile.',
                                                    de: 'Die Trainingsmethoden beschreiben Bereiche für spezifische Trainingsreize und basieren auf dem individuellen metabolischen Profil.',
                                                })), 1 /* TEXT */)
                                            ], 2 /* CLASS */)
                                        ], 10 /* CLASS, PROPS */, _hoisted_138)
                                    ], 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", _hoisted_140, [
                                    _cache[74] || (_cache[74] = _createElementVNode("th", {
                                        scope: "col",
                                        class: "font-normal w-27/100"
                                    }, null, -1 /* CACHED */)),
                                    _cache[75] || (_cache[75] = _createElementVNode("th", {
                                        scope: "col",
                                        class: "font-normal w-13/100"
                                    }, "min. [W]", -1 /* CACHED */)),
                                    _cache[76] || (_cache[76] = _createElementVNode("th", {
                                        scope: "col",
                                        class: "font-normal w-13/100"
                                    }, "max. [W]", -1 /* CACHED */)),
                                    _createElementVNode("th", _hoisted_141, _toDisplayString(_unref(___)({ en: 'Target value', de: 'Zielwert' })) + " [W]", 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_142, _toDisplayString(_unref(___)({ en: 'Guide value', de: 'Richtwert' })) + " [W]", 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_143, _toDisplayString(_unref(___)({ en: 'Guide value', de: 'Richtwert' })) + " [rpm]", 1 /* TEXT */)
                                ])
                            ]),
                            _createElementVNode("tbody", _hoisted_144, [
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zonefatmax.showEnergy, 'text-primary-500': zones.value.zonefatmax.hover }]),
                                    onMouseover: _cache[30] || (_cache[30] = ($event) => (zones.value.zonefatmax.hover = true)),
                                    onMouseleave: _cache[31] || (_cache[31] = ($event) => (zones.value.zonefatmax.hover = false)),
                                    onClick: _cache[32] || (_cache[32] = ($event) => (zones.value.zonefatmax.showEnergy = !zones.value.zonefatmax.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_145, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zonefatmax.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[77] || (_cache[77] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Fatmax (FM)', de: 'Fatmax (FM)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonefatmax.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_146)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonefatmax.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_147)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonefatmax.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_148)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonefatmax.rest.power)
                                        }, null, 8 /* PROPS */, _hoisted_149)
                                    ]),
                                    _cache[78] || (_cache[78] = _createElementVNode("td", null, "85-110", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zonefatmax.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_150, [
                                        _createElementVNode("td", _hoisted_151, [
                                            _createElementVNode("div", _hoisted_152, [
                                                _cache[33] || (_setBlockTracking(-1, true),
                                                    (_cache[33] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 33,
                                                    _setBlockTracking(1),
                                                    _cache[33])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Training in the range of maximum fat oxidation. Moderate intensity.',
                                                de: 'Training im Bereich der maximalen Fettoxidation. Moderate Intensität.',
                                            })), 1 /* TEXT */)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zoneie.showEnergy, 'text-primary-500': zones.value.zoneie.hover }]),
                                    onMouseover: _cache[34] || (_cache[34] = ($event) => (zones.value.zoneie.hover = true)),
                                    onMouseleave: _cache[35] || (_cache[35] = ($event) => (zones.value.zoneie.hover = false)),
                                    onClick: _cache[36] || (_cache[36] = ($event) => (zones.value.zoneie.showEnergy = !zones.value.zoneie.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_153, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zoneie.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[79] || (_cache[79] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Intermittent exercise (IE)', de: 'Intermittent exercise (IE)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zoneie.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_154)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zoneie.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_155)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zoneie.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_156)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zoneie.rest.power)
                                        }, null, 8 /* PROPS */, _hoisted_157)
                                    ]),
                                    _cache[80] || (_cache[80] = _createElementVNode("td", null, "85-110", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zoneie.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_158, [
                                        _createElementVNode("td", _hoisted_159, [
                                            _createElementVNode("div", _hoisted_160, [
                                                _cache[37] || (_setBlockTracking(-1, true),
                                                    (_cache[37] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 37,
                                                    _setBlockTracking(1),
                                                    _cache[37])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Intermittent intervals to improve VO2max. High to very high intensity.',
                                                de: 'Intermittierende Intervallform zur Verbesserung der VO2max. Hohe bis sehr hohe Intensität.',
                                            })), 1 /* TEXT */)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zonevo2max.showEnergy, 'text-primary-500': zones.value.zonevo2max.hover }]),
                                    onMouseover: _cache[38] || (_cache[38] = ($event) => (zones.value.zonevo2max.hover = true)),
                                    onMouseleave: _cache[39] || (_cache[39] = ($event) => (zones.value.zonevo2max.hover = false)),
                                    onClick: _cache[40] || (_cache[40] = ($event) => (zones.value.zonevo2max.showEnergy = !zones.value.zonevo2max.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_161, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zonevo2max.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[81] || (_cache[81] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'VO2max', de: 'VO2max' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonevo2max.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_162)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonevo2max.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_163)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonevo2max.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_164)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonevo2max.rest.power)
                                        }, null, 8 /* PROPS */, _hoisted_165)
                                    ]),
                                    _cache[82] || (_cache[82] = _createElementVNode("td", null, "85-110", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zonevo2max.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_166, [
                                        _createElementVNode("td", _hoisted_167, [
                                            _createElementVNode("div", _hoisted_168, [
                                                _cache[41] || (_setBlockTracking(-1, true),
                                                    (_cache[41] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 41,
                                                    _setBlockTracking(1),
                                                    _cache[41])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Interval training to improve VO2max. Very high intensity.',
                                                de: 'Intervallform zur Verbesserung der VO2max. Sehr hohe Intensität.',
                                            })), 1 /* TEXT */)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(["cursor-pointer", { expanded: zones.value.zonelc.showEnergy, 'text-primary-500': zones.value.zonelc.hover }]),
                                    onMouseover: _cache[42] || (_cache[42] = ($event) => (zones.value.zonelc.hover = true)),
                                    onMouseleave: _cache[43] || (_cache[43] = ($event) => (zones.value.zonelc.hover = false)),
                                    onClick: _cache[44] || (_cache[44] = ($event) => (zones.value.zonelc.showEnergy = !zones.value.zonelc.showEnergy))
                                }, [
                                    _createElementVNode("td", _hoisted_169, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["print:hidden inline-block w-3.5 h-3.5 me-1 transition-transform", zones.value.zonelc.showEnergy ? 'rotate-90' : '']),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16"
                                        }, [...(_cache[83] || (_cache[83] = [
                                                _createElementVNode("path", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M5 14l6-6-6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */)),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'Lactate Clearance (LC)', de: 'Laktat Auf-/Abbau (LC)' })), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonelc.min.power)
                                        }, null, 8 /* PROPS */, _hoisted_170)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonelc.max.power)
                                        }, null, 8 /* PROPS */, _hoisted_171)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonelc.avg.power)
                                        }, null, 8 /* PROPS */, _hoisted_172)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(zones.value.zonelc.rest.power)
                                        }, null, 8 /* PROPS */, _hoisted_173)
                                    ]),
                                    _cache[84] || (_cache[84] = _createElementVNode("td", null, "85-110", -1 /* CACHED */))
                                ], 34 /* CLASS, NEED_HYDRATION */),
                                (zones.value.zonelc.showEnergy)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_174, [
                                        _createElementVNode("td", _hoisted_175, [
                                            _createElementVNode("div", _hoisted_176, [
                                                _cache[45] || (_setBlockTracking(-1, true),
                                                    (_cache[45] = _createVNode(SvgVue, {
                                                        class: "h-[0.75lh] w-auto",
                                                        icon: "lucide/lightbulb"
                                                    })).cacheIndex = 45,
                                                    _setBlockTracking(1),
                                                    _cache[45])
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(_unref(___)({
                                                en: 'Training of lactate clearance. Medium to high intensity.',
                                                de: 'Training des Laktatabbaus. Mittlere bis hohe Intensität.',
                                            })), 1 /* TEXT */)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_177, [
                    _cache[46] || (_setBlockTracking(-1, true),
                        (_cache[46] = _createVNode(SvgVue, {
                            class: "w-3 h-3 inline-block",
                            icon: "lucide/chevron-left"
                        })).cacheIndex = 46,
                        _setBlockTracking(1),
                        _cache[46]),
                    _cache[85] || (_cache[85] = _createTextVNode("swipe me", -1 /* CACHED */)),
                    _cache[47] || (_setBlockTracking(-1, true),
                        (_cache[47] = _createVNode(SvgVue, {
                            class: "w-3 h-3 inline-block",
                            icon: "lucide/chevron-right"
                        })).cacheIndex = 47,
                        _setBlockTracking(1),
                        _cache[47])
                ])
            ]));
        };
    }
});
